import { css } from '@emotion/react';

export const boxModel = () => {
  return css`
    .m-half {
      margin: 4px;
    }
    .mt-half {
      margin-top: 4px;
    }
    .mb-half {
      margin-bottom: 4px;
    }
    .ml-half {
      margin-left: 4px;
    }
    .mr-half {
      margin-right: 4px;
    }
    .mx-half {
      margin-left: 4px;
      margin-right: 4px;
    }
    .my-half {
      margin-top: 4px;
      margin-bottom: 4px;
    }
    .p-half {
      padding: 4px;
    }
    .pt-half {
      padding-top: 4px;
    }
    .pb-half {
      padding-bottom: 4px;
    }
    .pl-half {
      padding-left: 4px;
    }
    .pr-half {
      padding-right: 4px;
    }
    .px-half {
      padding-left: 4px;
      padding-right: 4px;
    }
    .py-half {
      padding-top: 4px;
      padding-bottom: 4px;
    }
    ${Array(12)
      .fill(1)
      .reduce((previousValue, _, currentIndex) => {
        const index = currentIndex - 1;
        const sizePrefix = 'half';
        const drainage = 8;
        const halfDrainage = drainage / 2;

        return css`
          ${previousValue}
          .m-${index} {
            margin: ${index * drainage}px !important;
          }
          .mt-${index} {
            margin-top: ${index * drainage}px !important;
          }
          .mr-${index} {
            margin-right: ${index * drainage}px !important;
          }
          .mb-${index} {
            margin-bottom: ${index * drainage}px !important;
          }
          .ml-${index} {
            margin-left: ${index * drainage}px !important;
          }
          .mx-${index} {
            margin-left: ${index * drainage}px !important;
            margin-right: ${index * drainage}px !important;
          }
          .my-${index} {
            margin-top: ${index * drainage}px !important;
            margin-bottom: ${index * drainage}px !important;
          }
          .m-m-${index} {
            margin: ${index * -drainage}px !important;
          }
          .mt-m-${index} {
            margin-top: ${index * -drainage}px !important;
          }
          .mr-m-${index} {
            margin-right: ${index * -drainage}px !important;
          }
          .mb-m-${index} {
            margin-bottom: ${index * -drainage}px !important;
          }
          .ml-m-${index} {
            margin-left: ${index * -drainage}px !important;
          }
          .mx-m-${index} {
            margin-left: ${index * -drainage}px !important;
            margin-right: ${index * -drainage}px !important;
          }
          .my-m-${index} {
            margin-top: ${index * -drainage}px !important;
            margin-bottom: ${index * -drainage}px !important;
          }
          .p-${index} {
            padding: ${index * drainage}px !important;
          }
          .pt-${index} {
            padding-top: ${index * drainage}px !important;
          }
          .pr-${index} {
            padding-right: ${index * drainage}px !important;
          }
          .pb-${index} {
            padding-bottom: ${index * drainage}px !important;
          }
          .pl-${index} {
            padding-left: ${index * drainage}px !important;
          }
          .px-${index} {
            padding-left: ${index * drainage}px !important;
            padding-right: ${index * drainage}px !important;
          }
          .py-${index} {
            padding-top: ${index * drainage}px !important;
            padding-bottom: ${index * drainage}px !important;
          }
          .p-m-${index} {
            padding: ${index * -drainage}px !important;
          }
          .pt-m-${index} {
            padding-top: ${index * -drainage}px !important;
          }
          .pr-m-${index} {
            padding-right: ${index * -drainage}px !important;
          }
          .pb-m-${index} {
            padding-bottom: ${index * -drainage}px !important;
          }
          .pl-m-${index} {
            padding-left: ${index * -drainage}px !important;
          }
          .px-m-${index} {
            padding-left: ${index * -drainage}px !important;
            padding-right: ${index * -drainage}px !important;
          }
          .py-m-${index} {
            padding-top: ${index * -drainage}px !important;
            padding-bottom: ${index * -drainage}px !important;
          }
          .m-${sizePrefix}-${index} {
            margin: ${index * halfDrainage}px !important;
          }
          .mt-${sizePrefix}-${index} {
            margin-top: ${index * halfDrainage}px !important;
          }
          .mr-${sizePrefix}-${index} {
            margin-right: ${index * halfDrainage}px !important;
          }
          .mb-${sizePrefix}-${index} {
            margin-bottom: ${index * halfDrainage}px !important;
          }
          .ml-${sizePrefix}-${index} {
            margin-left: ${index * halfDrainage}px !important;
          }
          .mx-${sizePrefix}-${index} {
            margin-left: ${index * halfDrainage}px !important;
            margin-right: ${index * halfDrainage}px !important;
          }
          .my-${sizePrefix}-${index} {
            margin-top: ${index * halfDrainage}px !important;
            margin-bottom: ${index * halfDrainage}px !important;
          }
          .m-${sizePrefix}-m-${index} {
            margin: ${index * -halfDrainage}px !important;
          }
          .mt-${sizePrefix}-m-${index} {
            margin-top: ${index * -halfDrainage}px !important;
          }
          .mr-${sizePrefix}-m-${index} {
            margin-right: ${index * -halfDrainage}px !important;
          }
          .mb-${sizePrefix}-m-${index} {
            margin-bottom: ${index * -halfDrainage}px !important;
          }
          .ml-${sizePrefix}-m-${index} {
            margin-left: ${index * -halfDrainage}px !important;
          }
          .mx-${sizePrefix}-m-${index} {
            margin-left: ${index * -halfDrainage}px !important;
            margin-right: ${index * -halfDrainage}px !important;
          }
          .my-${sizePrefix}-m-${index} {
            margin-top: ${index * -halfDrainage}px !important;
            margin-bottom: ${index * -halfDrainage}px !important;
          }
          .p-${sizePrefix}-${index} {
            padding: ${index * halfDrainage}px !important;
          }
          .pt-${sizePrefix}-${index} {
            padding-top: ${index * halfDrainage}px !important;
          }
          .pr-${sizePrefix}-${index} {
            padding-right: ${index * halfDrainage}px !important;
          }
          .pb-${sizePrefix}-${index} {
            padding-bottom: ${index * halfDrainage}px !important;
          }
          .pl-${sizePrefix}-${index} {
            padding-left: ${index * halfDrainage}px !important;
          }
          .px-${sizePrefix}-${index} {
            padding-left: ${index * halfDrainage}px !important;
            padding-right: ${index * halfDrainage}px !important;
          }
          .py-${sizePrefix}-${index} {
            padding-top: ${index * halfDrainage}px !important;
            padding-bottom: ${index * halfDrainage}px !important;
          }
          .p-${sizePrefix}-m-${index} {
            padding: ${index * -halfDrainage}px !important;
          }
          .pt-${sizePrefix}-m-${index} {
            padding-top: ${index * -halfDrainage}px !important;
          }
          .pr-${sizePrefix}-m-${index} {
            padding-right: ${index * -halfDrainage}px !important;
          }
          .pb-${sizePrefix}-m-${index} {
            padding-bottom: ${index * -halfDrainage}px !important;
          }
          .pl-${sizePrefix}-m-${index} {
            padding-left: ${index * -halfDrainage}px !important;
          }
          .px-${sizePrefix}-m-${index} {
            padding-left: ${index * -halfDrainage}px !important;
            padding-right: ${index * -halfDrainage}px !important;
          }
          .py-${sizePrefix}-m-${index} {
            padding-top: ${index * -halfDrainage}px !important;
            padding-bottom: ${index * -halfDrainage}px !important;
          }
        `;
      }, '')}
  `;
};
